export function hideImage() {
  if (document.getElementById('124')) {
    document.getElementById('124').classList.remove('show');
    document.getElementById('124').classList.add('hidden');
  }
}
